import { ScrollView } from "react-native";

export default function Index() {
  return (
    <ScrollView>
      <h1>Dev Navigation</h1>
      <p>Click on these links to see examples.</p>
      <Example
        title="Full componentes rendered for all examples"
        href="/dev/full-examples"
        copy="Render all examples as full components. This takes a while to load."
      />
      <Example
        title="Examples as JSON"
        href="/dev/examples-as-json"
        copy="Fetch data from Notion and then fetch data from our API. Used to see obvious errors in API layer."
      />

      <Example title="Debug" href="/dev/debug" copy="Debugging FigmaImage" />
      <br />
      <h2>Sub-components</h2>

      <Example
        title="ETA Examples"
        href="/dev/eta-examples"
        copy="List of timestamps in humanreadable format"
      />
      <Example
        title="Status icons"
        href="/dev/status-icons"
        copy="All status icons from examples"
      />
      <Example
        title="Progress bars"
        href="/dev/progress-bars"
        copy="Render Figma component next to progress bars"
      />
      <Example
        title="Progress bars for legacy fulfillments"
        href="/dev/legacy-fulfillment-progress-bars"
        copy="Render Figma component next to progress bars"
      />
      <Example title="CTAs" href="/dev/ctas" copy="CTAs from notion" />
      <Example
        title="Historial"
        href="/dev/historical"
        copy="Historical data for a specific order"
      />
      <Example
        title="Cart Items"
        href="/dev/cart"
        copy="Shows the order details"
      />
      <br />
      <h2>Random</h2>
      <Example
        title="Historial Dup"
        href="/dev/historical-dup"
        copy="Historical data for one order that had lots of dup events"
      />
      <Example
        title="ETA Playground"
        href="/dev/eta"
        copy="Table with pickers and different values returned by date-fns"
      />
      <Example
        title="Examples from Notion"
        href="/dev/examples"
        copy="Renders the notion database as html"
      />
      <Example
        title="Websockets"
        href="/dev/websocket"
        copy="Push data from a console directly to this view"
      />
      <Example
        title="Database Query"
        href="/dev/query"
        copy="Proof of concept to query a database for quick prototyping"
      />
    </ScrollView>
  );
}

function Example({
  title,
  href,
  copy,
}: Record<"title" | "href" | "copy", string>) {
  return (
    <div>
      <h3>{title}</h3>
      <a href={href}>{copy}</a>
    </div>
  );
}
